import {
    Box,
    HStack,
    Text,
    Flex,
    useDisclosure,
    Drawer,
    DrawerContent,
    DrawerOverlay,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import NavLinks from './NavLinks';
import { IoIosMenu } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';
import MobileNav from './MobileNav';
import { Link } from 'react-router-dom';
import { useCollections } from '../../providers/CollectionsProvider';
import { useCarts } from '../../providers/CartProvider';
export default function NavBar() {


    const { isOpen, onOpen, onClose } = useDisclosure();
    // const [searchEnabled, setsearchEnabled] = useState(false);
    // const { carts } = useCarts();

    // const [searchText, setSearchText] = useState("");
    const [openMenu, setopenMenu] = useState("")

    const { carts } = useCarts();

    return (
        <>
            <Box
                // bg='#054E47'
                bg='#ffffff'
                position='sticky'
                top='0'
                px={4}
                zIndex='2' m={0}>
                <Flex
                    h={20}
                    maxW='100vw'
                    display={['none', 'none', 'flex', 'flex']} alignItems={'center'} justifyContent={'space-between'}>
                    <HStack
                        w='100%'
                        spacing={5}
                        alignItems={'center'} >

                        <HStack
                            as={'nav'}
                            w='100%'
                            alignItems={'center'} justifyContent={'center'} spacing={2} display={{ base: 'none', md: 'flex' }}>
                            <NavLinks />
                        </HStack>

                    </HStack>
                </Flex>
                <Flex h={20}
                    maxW='100vw'
                    display={['flex', 'flex', 'none', 'none']}
                    alignItems={'center'}
                    justifyContent={'space-between'} 
                >
                    <IoIosMenu
                        color='#000000'
                        size='200px'
                        onClick={() => onOpen()}
                    />
                    <Flex
                        as={Link}
                        to='/'
                        justifyContent={'center'}
                        alignItems={'center'}
                        p={2}
                        pl={20}
                        mr='2'
                    >
                        <img
                            src={'/logo-dark.png'}
                            alt='Logo'
                        /></Flex>
                    <HStack
                        as={Link}
                        to='/cart'
                        w='80px'
                        h='auto'
                        minW='80px'
                        spacing={1}
                        justifyContent='flex-end'
                        alignItems={'center'}
                    >
                        <img src='/cart.png' width='44' />
                        {/* Show text on top of this icon  */}
                        {/* <Text fontSize='md' color={'#966754'}>Cart</Text> */}
                        <Flex
                            position='absolute'
                            top='15px'
                            borderRadius={'50%'}
                            bg={'primary.800'}
                            color={'#fefefe'}
                            w={'20px'}
                            h={'20px'}
                            justifyContent={'center'}
                            alignItems='center'
                        >
                            {carts.length}
                        </Flex>
                    </HStack>

                </Flex>

                <Drawer
                    isOpen={isOpen}
                    placement='left'
                    size='full'
                    onClose={onClose}
                >
                    <DrawerOverlay />
                    <DrawerContent>
                        <MobileNav onClose={onClose} />
                    </DrawerContent>
                </Drawer>

            </Box >
        </>
    )
}
